import { useQuery } from '@tanstack/react-query'
import { queryClient } from '../App'
import { getIncedentTypes } from '../services/NewApiService'

export const useIncidentTypes = () => {
  return useQuery(
    {
      queryKey: ['incedent-types'],
      queryFn: () => getIncedentTypes(),
      staleTime: Infinity,
      placeholderData: [],
      select: (data) => data.map((el) => ({ value: el.name, key: el.id })),
    },
    queryClient,
  )
}
